import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMenuFocusStore = defineStore('menuFocus', () => {
  /** Menu branch_id highlighted by system `:requestFocus` (no action). */
  const focusedMenuId = ref<string | null>(null)
  /** Bumps to force expand/scroll even if same id repeats. */
  const focusEpoch = ref(0)

  function focusMenuNode(menuId: string | number | null | undefined): boolean {
    if (menuId === undefined || menuId === null || menuId === '') return false
    const normalized = String(menuId)
    if (normalized === '-1') return false
    focusedMenuId.value = normalized
    focusEpoch.value += 1
    return true
  }

  function clearFocus(): void {
    focusedMenuId.value = null
  }

  function reset(): void {
    focusedMenuId.value = null
    focusEpoch.value = 0
  }

  return {
    focusedMenuId,
    focusEpoch,
    focusMenuNode,
    clearFocus,
    reset,
  }
})
